import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingScreen } from '../../components/LoadingScreen';

const DEFAULT_MARKETING_ORIGIN = 'https://cantir.it';

function marketingOrigin(): string {
  const raw = import.meta.env.VITE_MARKETING_SITE_ORIGIN as string | undefined;
  if (raw && /^https?:\/\//i.test(raw.trim())) {
    return raw.trim().replace(/\/$/, '');
  }
  return DEFAULT_MARKETING_ORIGIN;
}

/** Redirect da vecchie route marketing della SPA verso il sito Astro (`cantir-landing`). */
function redirectUrl(pathname: string, search: string): string {
  const base = marketingOrigin();
  const q = search && pathname !== '/features' ? search : '';
  switch (pathname) {
    case '/':
      return `${base}/${q}`;
    case '/contact':
      return `${base}/contact${q}`;
    case '/privacy':
      return `${base}/privacy${q}`;
    case '/terms':
      return `${base}/terms${q}`;
    case '/features':
      return `${base}/#features`;
    case '/pricing':
      return `${base}/${q}`;
    default:
      return `${base}/${q}`;
  }
}

/**
 * Sostituisce la vecchia area pubblica (landing React). Chiamate a `/`, `/contact`, … su host app
 * vengono mandate al marketing statico.
 */
export function LegacyMarketingRedirectPage() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.location.replace(redirectUrl(pathname, search));
  }, [pathname, search]);

  return <LoadingScreen />;
}
